module.exports = __webpack_public_path__ + "static/media/mode-56.c486decd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-56.svg
// module id = 1028
// module chunks = 2